<template>
<div class="passer-container">
 
  <div class="container">
        <TopNav />

    <div class="passer">
        <MainNavbar active='Mes' />
      
        <div class="passer-content">
            <h1>Mes commandes</h1>

            <div class="head-line">
                 <headline />
            </div>
        
            <div class="table one">
                <div class="left-border"></div>

                <div class="table-content">

                       <div class="table-border-right one"></div>
                      <div class="table-border-right two"></div>
                      <div class="table-border-right three"></div>
                      <div class="table-border-right four"></div>


                  <div class="table-content-rows">
                  <div class="head-row">
                        <h5>Reféférence</h5>
                        <h5>Date de <br> commande</h5>
                        <h5>Etat de la <br> commande</h5>
                        <h5>Montant</h5>
                        <h5 style="border-top-right-radius: 71px;border-bottom-right-radius:71px">Réglement</h5>
                  </div>

                      <div class="table-content-row">
                        <p class="table-ref">
                          #RZG960 
                          <img src="../assets/mes/edit.png" alt=""></p>
                        <p class="date-ref">
                          <span class="text-ref">
                            26/04/2021
                          </span>
                        </p>

                        <p class="table-commande">En cours</p>
                        <p class="table-montant">En calcul</p>
                        <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/indisp.png" alt=""></p>
                      </div>

                        <div class="table-content-row">
                            <p class="table-ref">#RZG960<img src="../assets/mes/edit.png" alt=""> </p>
                            <p class="date-ref">26/04/2021</p>
                            <p class="table-commande">En cours</p>
                            <p class="table-montant">En calcul</p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/indisp.png" alt=""></p>
                      </div>

                        <div class="table-content-row">
                            <p class="table-ref">#RZG960<img src="../assets/mes/edit.png" alt=""> </p>
                            <p class="date-ref">26/04/2021</p>
                            <p class="table-commande">En cours</p>
                            <p class="table-montant">En calcul</p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/indisp.png" alt=""></p>
                      </div>

                         <div class="table-content-row">
                            <p class="table-ref">#AVW80<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 .85em"> </p>
                            <p class="date-ref">26/04/2021</p>
                            <p class="table-commande">Traitée</p>
                            <p class="table-montant">869 €</p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/btn_send.png" alt="" ></p>
                        </div>

                        <div class="table-content-row">
                            <p class="table-ref">#AVW80<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 .85em"> </p>
                            <p class="date-ref">26/04/2021</p>
                            <p class="table-commande">Traitée</p>
                            <p class="table-montant">869 €</p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/btn_send.png" alt="" ></p>
                        </div>
                        <div class="table-content-row no-border">
                            <p class="table-ref">#AVW80<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 .85em"> </p>
                            <p class="date-ref">26/04/2021</p>
                            <p class="table-commande">Traitée</p>
                            <p class="table-montant">869 €</p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/btn_send.png" alt="" ></p>
                        </div>


                  </div>
                </div>
            </div>

             <div class="head-line two">
                 <headline2 />
            </div>
        
            <div class="table two">
                <div class="left-border"></div>

                <div class="table-content">


                  <div class="table-content-rows">

                      <div class="head-row">
                            <h5>Reféférence</h5>
                            <h5 style="white-space:nowrap">Livraison prévue <br> pour le</h5>
                            <h5>Tracking <br> livraison</h5>
                            <h5>Tracking <br> livraison</h5>
                            <h5 style="border-top-right-radius: 71px;border-bottom-right-radius:71px">Chaîne du <br> Froid</h5>
                      </div>

                      <div class="table-border-right one"></div>
                      <div class="table-border-right two"></div>
                      <div class="table-border-right three"></div>
                      <div class="table-border-right four"></div>


                      <div class="table-content-row">
                        <p class="table-ref">
                          #RZG960 
                          <img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 .85em"></p>
                        <p class="date-ref">
                          <span class="text-ref">
                            26/04/2021
                          </span>
                        </p>

                        <p class="table-commande">En livraison</p>
                        <p class="table-montant"><img src="../assets/mes/table2sym1.png" alt=""></p>
                        <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym2.png" alt=""></p>
                      </div>

                        <div class="table-content-row">
                            <p class="table-ref">#RZG960<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 .85em"> </p>
                            <p class="date-ref">26/04/2021</p>
                            <p class="table-commande">En livraison</p>
                            <p class="table-montant"><img src="../assets/mes/table2sym1.png" alt=""></p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym2.png" alt=""></p>
                      </div>

                        <div class="table-content-row">
                            <p class="table-ref">#RZG960<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 .85em"> </p>
                            <p class="date-ref">26/04/2021</p>
                            <p class="table-commande">En livraison</p>
                            <p class="table-montant"><img src="../assets/mes/table2sym1.png" alt=""></p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym2.png" alt=""></p>
                      </div>

                         <div class="table-content-row">
                            <p class="table-ref">#AVW80<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 1.2em"> </p>
                            <p class="date-ref">26/04/2021</p>
                            <p class="table-commande">Livraison imminente</p>
                            <p class="table-montant"></p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym3.png" alt="" ></p>
                        </div>

                        <div class="table-content-row">
                            <p class="table-ref">#AVW80<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 1.2em"> </p>
                            <p class="date-ref">26/04/2021</p>
                            <p class="table-commande">Livraison imminente</p>
                            <p class="table-montant"></p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym3.png" alt="" ></p>
                        </div>
                        <div class="table-content-row no-border">
                            <p class="table-ref">#AVW80<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 1.2em"> </p>
                            <p class="date-ref">26/04/2021</p>
                            <p class="table-commande">Livraison imminente</p>
                            <p class="table-montant"></p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym3.png" alt="" ></p>
                        </div>


                  </div>
                </div>
            </div>



            <div class="head-line three">
                 <headline3 />
            </div>
        
            <div class="table three">
                <div class="left-border"></div>

                <div class="table-content">


                  <div class="table-content-rows">

                  <div class="head-row">
                        <h5>Reféférence</h5>
                        <h5 style="white-space:nowrap">Livraison prévue <br> pour le</h5>
                        <h5>Tracking <br> livraison</h5>
                        <h5>Tracking <br> livraison</h5>
                        <h5 style="border-top-right-radius: 71px;border-bottom-right-radius:71px">Chaîne du <br> Froid</h5>
                  </div>

                      <div class="table-border-right one"></div>
                      <div class="table-border-right two"></div>
                      <div class="table-border-right three"></div>
                      <div class="table-border-right four"></div>


                      <div class="table-content-row">
                        <p class="table-ref">
                          #RZG960 
                          <img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 .85em"></p>
                        <p class="date-ref">
                          <span class="text-ref">
                            26/04/2021 
                          </span> <img src="../assets/mes/table3/tracking.png" alt=""  style="display: block;height:30px">
                        </p>

                        <p class="table-commande">Livré</p>
                        <p class="table-montant">7,5 €</p>
                        <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym2.png" alt=""></p>
                      </div>

                        <div class="table-content-row">
                            <p class="table-ref">#RZG960<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 .85em"> </p>
                            <p class="date-ref">26/04/2021 <img src="../assets/mes/table3/tracking.png" alt=""  style="display: block;height:30px;margin: 5px 10px;"></p>
                            <p class="table-commande">Livré</p>
                            <p class="table-montant">7,5 €</p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym2.png" alt=""></p>
                      </div>

                        <div class="table-content-row">
                            <p class="table-ref">#RZG960<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 .85em"> </p>
                            <p class="date-ref">26/04/2021 <img src="../assets/mes/table3/tracking.png" alt=""  style="display: block;height:30px;margin: 0 10px;"></p>
                            <p class="table-commande">Absent</p>
                            <p class="table-montant">7,5 €</p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym2.png" alt=""></p>
                      </div>

                         <div class="table-content-row">
                            <p class="table-ref">#AVW80<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 1.2em"> </p>
                            <p class="date-ref">26/04/2021 <img src="../assets/mes/table3/tracking.png" alt=""  style="display: block;height:30px;margin: 0 10px;"></p>
                            <p class="table-commande">Livré</p>
                            <p class="table-montant">7,5 €</p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym3.png" alt="" ></p>
                        </div>

                        <div class="table-content-row">
                            <p class="table-ref">#AVW80<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 1.2em"> </p>
                            <p class="date-ref">26/04/2021 <img src="../assets/mes/table3/tracking.png" alt=""  style="display: block;height:30px;margin: 0 10px;"></p>
                            <p class="table-commande">Livré</p>
                            <p class="table-montant">7,5 €</p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym3.png" alt="" ></p>
                        </div>
                        <div class="table-content-row no-border">
                            <p class="table-ref">#AVW80<img src="../assets/mes/view.png" alt="" style="height:25px;width:25px;padding:0 1.2em"> </p>
                            <p class="date-ref">26/04/2021 <img src="../assets/mes/table3/tracking.png" alt=""  style="display: block;height:30px;margin: 0 10px;"></p>
                            <p class="table-commande">Livré</p>
                            <p class="table-montant">7,5 €</p>
                            <p class="table-reg"  style="border: none !important;"><img src="../assets/mes/tab2sym3.png" alt="" ></p>
                        </div>


                  </div>
                </div>
            </div>  

        </div>
    </div>
    </div>
    
  </div>

</template>

<script>
import MainNavbar from '../components/MainNavbar.vue'
import TopNav from '../components/TopNav.vue'
import headline from '../components/mes-commandes/headline.vue'
import headline2 from '../assets/mes/headline2.vue'
import headline3 from '../assets/mes/table3/tab3head.vue'

export default {
  name: 'Passer',
  components: {
    MainNavbar,
    TopNav,
    headline,
    headline2,
    headline3
  }
}
</script>

<style scoped>
  .passer-container{
      background:#F5F6F7;padding: 10px;
  }
  .passer{
    display: flex;
    font-family: 'Open Sans', sans-serif;
  }

  .passer-content{
    max-width: 75%;
    margin: 2em 0;
}
  .passer-content h1{
    font-size: 67px;
    display: block;
    margin: 1em 0;
  }
  .passer-info{
    display: block;
    /* background: red; */
      /* margin: 3em 0; */
      padding: 2em 0;
  }

  .passer-info-item{
    display: flex;
    margin: 3em 0em;
  }
  .passer-info-item img{
      height: 75px;
      width: 70px;
      display: block;
      margin: 0 2em;
      object-fit: contain;
  }
  .passer-info-item h5{
    display: block;
    font-size: 30px;
    color: #59626A
}
  .passer-info-item h5 span{
    color: rgba(0, 0, 0, 0.575);
  }

  .file-input{
    display: flex;
    width: clamp(400px,65vw,1000px);
  } 
  .file-input .inp-link{
    width: 50%;
    /* background: #000; */
}
  .file-input .inp-link img{
    width: 100%;
    height: 100%;
  }
  
  .file-input-large{
    margin: 0em 2em 0 2em;
    /* background: #000; */
  }
  .file-input-large img{
    height: 600px;
  }

  #Raj img, #Date img{
    display: block;
    margin: 2em 0 2em 1em;
   width: clamp(300px,60vw,900px);
  }

  .passer-card{
     width: clamp(300px,65vw,1000px);
    margin: 2em 0 2em 1em;

  } 
  #Group_2962{
    fill: white;
    cursor: pointer;
  }

  .AdressIcon{
     /* width: clamp(300px,37vw,1000px); */
     /* background: #000; */
    margin: 0 5em;
  }
  .Ajou{
    display: block;
     width: clamp(300px,60vw,1000px);
    margin: 2em 0 2em 1em;
    
  }
  .DateIcon{
    display: block;
    margin: 2em 0 2em 1em;
   width: clamp(300px,60vw,1000px);

  }
  .Calender{

    display: block;
    margin: 2em 0 2em 1em;
   width: clamp(300px,60vw,1000px);
  }
  .Calender img{
    display: block;width: 100%;height: 100%;
    cursor: pointer;
  }
</style>

// table styles

<style scoped>
.head-line{
  max-width: 900px;
}
.table{
  /* background: red; */
    display: flex;
    height: 750px;
    margin: 1em;
    max-width: 1200px;
    width: 1200px;
  border-radius: 71px;
  border-top-left-radius: 71px;
    margin: 3em 0em;
}



.left-border{
  width: 90px;
  height: 100%;
  border-top-left-radius: 71px;
  /* border-top-right-radius: 71px; */
  border-bottom-right-radius: 71px;
  background: #3498DB;
  border-bottom-left-radius: 71px;
}

.table-content{
  width: 100%;
}

.head-row{ 
   background: #3498DB;
  color: #fff;
  display: flex;
  width: 100%;
  font-size: 33px;
  /* padding: .5em 0; */
  border-top-right-radius: 71px;
  border-bottom-right-radius: 71px;
  position: relative;
}

.head-row::after{
  content: '';
  position: absolute;
  top: 101%;
  left: 0;
  width: 100%;
  border-bottom:1px solid #3498DB;
}
.head-row h5{
  padding: 1em .25em;
  /* padding: 1em .0em; */
  /* border-right: 1px dashed #fff; */
  text-align: center;
  width: 20%;
  max-width: 20%;
}
.head-row h5:nth-of-type(1){
  padding: 1em .5em;
  font-size: .95em;
}
.head-row h5:nth-of-type(2),
.head-row h5:nth-of-type(3){
  padding:  .5em;
}
.head-row h5:nth-last-of-type(){
 
}
.table-content{
  position: relative;
}

.table-border-right{
  position: absolute;
  top: 0;
  /* background: red; */
  height: 70%;
  border-right: 3px dashed rgba(0, 0, 0, 0.2);
  width: 1px;
  z-index: 10;
}
.table-border-right.one{ left: 14em;}
.table-border-right.two{ left: 28em;}
.table-border-right.three{ left: 42em;}
.table-border-right.four{ left: 54.5em;}
.table-content-row{
  display: flex;
  background: #fff;
  padding: .5em 0em;
  width: 100%;

}
.table-content-row{
  position: relative;

}
.table-content-row::before{
  content: '';
  position: absolute;
  top: 80%;
  left: 0;
  height: 10px;
  width: 100%;
  /* background: red; */
  border-bottom:2px solid #3498DB;
} 

.table-content-row.no-border::before{
  border: none;
}
.table-content-row p{
  display: flex;
  font-size: 30px;
  width: 20%;
  max-width: 20%;
  background: #fff;
  height: 50px;
  text-align: center;
  color:#153288;
  opacity:  0.5;
}

.table-content-row p:nth-of-type(1),
.table-content-row p:nth-of-type(5){
  opacity: 1;
}
.table-content-row span:nth-of-type(2),
.table-content-row span:nth-of-type(3){
  /* padding:  0em; */
  /* width: 29%; */
}
.table-content-row span img{
}
.table-content-row .table-ref{
  /* background: red; */
  padding: .1em .5em;
  width: 20%;
  max-width: 20%;
}
.table-content-row .table-ref img{
  /* padding: .25em 0; */
  padding: 5px 20px;
  height: 20px;
  width: 20px;
  /* background: red; */
}
.table-content-row .date-ref{
  /* padding: 0 .25em; */
  /* background: red; */
  width: 20%;
  max-width: 20%;
  /* transform: translate(10px,10px); */
}

.text-ref{
  background: #fff;
  padding: .1em .25em;
}

.table-content-row .table-commande{
  /* background: rgb(255, 48, 48); */
  /* margin: 0 1em; */
  text-align: center;
  display: block;
}

.table-content-row .table-montant{
  display: block;
  /* background: red; */

}

.table-content-row .table-reg{
  /* background: red; */

}

.table-content-row .table-reg img{
  height: 40px;
  width: 150px;
}



</style>

// table two 
<style scoped>
.table.two{
  background: #fff;
}
.two .left-border{
  background: #D11C48;
}
.two .head-row{
  background: #D11C48;
}
.two .head-row h5:nth-of-type(1) {
}

.two .head-row h5:nth-of-type(2){

}
.two .head-row h5:nth-of-type(2),.two .head-row h5:nth-of-type(3) {
    padding: 1.2em .5em;
    font-size: 85%;
}
.two .table-border-right.two{
    left: 29.5em;
}

.two .table-border-right.one{ left: 13.5em;}
.two .table-border-right.two{ left: 29em;}
.two .table-border-right.three{ left: 42em;}
.two .table-border-right.four{ left: 55em;}

</style>


// table three
<style scoped>
.three .table-border-right.one{ left: 13.5em;}
.three .table-border-right.two{ left: 29em;}
.three .table-border-right.three{ left: 42em;}
.three .table-border-right.four{ left: 55em;}
 .three .table-content-row p, .head-row{ 
    /* font-size: 23px; */
    }
  .three .date-ref img{
  }
</style>
// Responsive table

<style scoped>
@media(max-width:1600px){
.table-content-row p, .head-row{ 
    /* background: red; */
}
}
@media(max-width:1700px){
.table-content-row p, .head-row{ 
    font-size: 29px;
    /* background: red; */
    /* background: rgba(255, 0, 0, 0.349); */

  }
  .three .table-content-row p, .head-row{ 
    /* font-size: 26px; */
    }
}


@media(max-width:1600px){
.table-border-right.one{ left: 12.5em;}
.table-border-right.two{ left: 25em;}
.table-border-right.three{ left: 39em;}
.table-border-right.four{ left: 49em;}

.two .table-border-right.one{ left: 12em;}
.two .table-border-right.two{ left: 26em;}
.two .table-border-right.three{ left: 38em;}
.two .table-border-right.four{ left: 49.5em;}

.three .table-border-right.one{ left: 12em;}
.three .table-border-right.two{ left: 26em;}
.three .table-border-right.three{ left: 38em;}
.three .table-border-right.four{ left: 49.5em;}

.table-content-row p, .head-row{ 
    font-size: 23px;
    /* background: rgba(0, 0, 0, 0.349); */
  }
  
  .head-row h5{
    padding: 1em .1em;
  }

  .table-content{
  max-width: 1000px;
  /* overflow: hidden; */
  }
}
@media(max-width:1500px){

  .table-content-row, .head-row{ 
    max-width: 90%;
  }
  .table-content-row p, .head-row{ 
    font-size: 20px;
    /* background: rgba(0, 0, 0, 0.349); */
  }
  .table-content{

    /* background: #000; */
  }
  .left-border{
  /* background: rgb(0,0,0); */
  width: 50px;
  }
}


</style>

<style scoped>

    @media(max-width:1550px){

      .passer{
        flex-direction: column;
        align-items: center;
    }
      
      .table-content-rows{
        /* width: 1200px; */
        overflow-y:auto;
        /* overflow-x:hidden;  */
      }

      .head-row h5:nth-of-type(1){
        padding: 1em 0;
        text-align: left;
      }

      .table-content-row,.head-row{
        width: 1201px;
        max-width: 1201px;
        overflow-x: auto;
      }

      .table-border-right{opacity: 0;}

      .passer-content{
        max-width: 95%;
        margin: .25em auto;
      }
      .head-line {
        max-width: 90vw;

      }
      .head-line svg {
        width: 100% !important;
      }
      /* .passer-content h1{
        font-size: 7vw;
          } */

          .left-border{width: 9vw;}

      .head-row h5 {
          /* font-size: 3vw; */
      }
      .table-content-row p {
          display: flex;
          /* font-size: 5vw; */
      }

      .file-input{width: 100%;}


    }


    @media (max-width:900px) {
       .table-content-rows{
        width: 78vw;
       }
        .table-content-row p {
          font-size: 5vw;
      }


    }
</style>

